import { useEffect, useRef, useState } from 'react';

const HeroImage = ({
  src,
  alt = '',
  className = '',
  fadeDuration = 900,
  zoomDuration = 10000,
  zoomScale = 1.18,
  startDelay = 350,
  onComplete,
}) => {
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), startDelay);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [startDelay]);

  useEffect(() => {
    if (!visible || !loaded || !onComplete) return;
    const timer = setTimeout(onComplete, fadeDuration);
    return () => clearTimeout(timer);
  }, [visible, loaded, fadeDuration, onComplete]);

  const active = visible && loaded;

  return (
    <div
      ref={containerRef}
      className={`relative w-full h-full overflow-hidden ${className}`}
    >
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className="absolute inset-0 w-full h-full object-cover"
        style={{
          opacity: active ? 1 : 0,
          transform: active ? `scale(${zoomScale})` : 'scale(1)',
          transition: `
            opacity ${fadeDuration}ms ease-out,
            transform ${zoomDuration}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)
          `,
          transformOrigin: 'center center',
          willChange: 'opacity, transform',
        }}
      />

      {/* Затемнение снизу */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent pointer-events-none" />
    </div>
  );
};

export default HeroImage;